module.exports = __webpack_public_path__ + "static/media/sidharthevent.8d3b7766.jpg";